module.exports = __webpack_public_path__ + "img/address.82a362f6.png";